import React, { useState, useRef, useEffect } from 'react'
import 'video.js/dist/video-js.css';
import BackNavbarLearning from '../../../ReusableBlocks/Navbar'
import Footer from '../../../ReusableBlocks/FooterBlock'
import Modal from 'react-bootstrap/Modal';
import { Link, useParams } from "react-router-dom";
import Quiz from './QuizModal';
import LoadingBar from '../../../Images/Animation - 1710409471189.json'
import CryptoJS from 'crypto-js';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLearningHub, updateVideoStatus } from '../../../Redux/Dashboard/External/LearningHub/LearningHubGetDataAction';
import { fetchLearningHubDetails } from '../../../Redux/Dashboard/External/LearningHub/LearningHubGetDetailsAction';
import * as PATH from '../../../CentralisedLink'
import ReactPlayer from 'react-player';
import Swal from 'sweetalert2';
import { getMediaProvider, normalizeMediaUrl } from '../../../Utils/mediaUrls';



const DemoCentralTraining = (props) => {


    const { id } = useParams();
    const [videoWatched, setVideoWatched] = useState(false);
    const iframeRef = useRef(null);


    const secretKey = 'micro';

    const decryptId = (encryptedId) => {
        const decodedId = decodeURIComponent(encryptedId);
        const bytes = CryptoJS.AES.decrypt(decodedId, secretKey);
        return bytes.toString(CryptoJS.enc.Utf8);
    };

    const [includeQuiz, setIncludeQuiz] = useState(false);
    const [screenSize, setScreenSize] = useState('');
    const [showQuizModal, setShowQuizModal] = useState(false);
    const [quizPassed, setQuizPassed] = useState(false); // State to track if the quiz is passed
    const [isQuizPassed, setIsQuizPassed] = useState(false); // Define the state for quiz passed
    const [showWhatsNew, setShowWhatsNew] = useState(false);
    const [fullPageloading, setFullPageLoading] = useState(true);
    const [loadingAnimation, setLoadingAnimation] = useState(LoadingBar);
    const [loadingTitle, setLoadingTitle] = useState("Ingestion In Progress!");
    const [badgde, setbadgde] = useState('');
    const [badgeModel, setBadgdeModel] = useState(false);
    const [playing, setPlaying] = useState(false);

    const handlePlayButtonClick = () => {
        setPlaying(true);
    };
    const handleShowBadgdeModel = () => setBadgdeModel(true);
    const handleCloseBadgdeModel = () => setBadgdeModel(false);

    const dispatch = useDispatch();
    const { getData } = useSelector((state) => state.LearningHubData);
    const { loading, getDetails, error } = useSelector((state) => state.LearningHubDetails);



    useEffect(() => {
        const decryptedId = decryptId(id);
        dispatch(fetchLearningHubDetails(decryptedId));
    }, [dispatch, id]);



    const microcertTitle = getData?.['mandatory-training']?.title;
    const question = getDetails?.['micro-cert']?.questions;
    const videoStatus = getData?.['mandatory-training']?.videoStatus;
    const QuizStatus = getData?.['mandatory-training']?.questionStatus;
    // const completeionBadgde = getData?.['mandatory-training']?.completionBadge;


    const temporaryCompletionBadge = useSelector((state) => state.temporaryCompletionBadge);
    const completeionBadgde = temporaryCompletionBadge || getData?.['mandatory-training']?.completionBadge;
    const [includeTrainingVideo, setIncludeTrainingVideo] = useState(videoStatus);
    const TrainingData = getDetails?.['micro-cert'] || []
    const AllTracks = getData?.['tracks'];

    // Get All Learning Hub Data
    const isLoadingData = useSelector(state => state.LearningHubData?.loading);
    const errorMessageData = useSelector(state => state.LearningHubData?.error);

    // Get Cert Details
    const isLoadingDetails = useSelector(state => state.LearningHubDetails?.loading);
    const errorMessageDetails = useSelector(state => state.LearningHubDetails?.error);










    const handleShowWhatsNew = () => setShowWhatsNew(true);
    const handleCloseWhatsNew = () => setShowWhatsNew(false);

      // Microcert Erro
  useEffect(() => {
    if (errorMessageDetails) {
      Swal.fire({
        title: 'Error',
        text: errorMessageDetails,
        icon: 'error',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [errorMessageDetails]); 

  // Learning Hub erros
  useEffect(() => {
    if (errorMessageData) {
      Swal.fire({
        title: 'Error',
        text: errorMessageData,
        icon: 'error',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [errorMessageData]); 


    useEffect(() => {
        if (videoStatus !== undefined) {
            setIncludeTrainingVideo(videoStatus);
        }
    }, [videoStatus]);

    useEffect(() => {
        if (QuizStatus !== undefined) {
            setIncludeQuiz(QuizStatus)
            setIsQuizPassed(QuizStatus)

        }
    }, [QuizStatus]);

    const handleContextMenu = (event) => {
        event.preventDefault(); // Prevents the context menu from appearing
    };

    const handleTrainingVideoChange = async () => {
        if (!includeTrainingVideo) { // Only proceed if it's not already checked
            try {
                const newVideoStatus = true;
                setIncludeTrainingVideo(newVideoStatus);
                console.log(id)
                const decryptedId = decryptId(id);
                const result = await dispatch(updateVideoStatus(decryptedId, getDetails?.['micro-cert']?.title));

                if (!result.success) {
                    console.error('Error details:', result.error);
                    setIncludeTrainingVideo(false);
                    throw new Error('Failed to update video status');
                } else {
                    dispatch(fetchLearningHub())
                }
            } catch (error) {
                console.error('Error updating video status:', error);
                setIncludeTrainingVideo(false); // Handle error case
            }
        }
    };







    const handleQuizChange = () => {
        setIncludeQuiz(!includeQuiz);
    };

    const handleShowQuizModal = () => {
        if (includeTrainingVideo) {
            setShowQuizModal(true);
        }
    };

    const handleCloseQuizModal = () => {
        setShowQuizModal(false);
    };

    // Handle when parameters or video URL change
    useEffect(() => {
        // Reset playing state and set new video URL
        console.log(playing)
        setPlaying(false);
    }, [TrainingData?.video]);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width <= 768) {
                setScreenSize('mobile');
            } else if (width <= 1024) {
                setScreenSize('tablet');
            } else {
                setScreenSize('desktop');
            }
        };

        handleResize(); // Call on initial render
        window.addEventListener('resize', handleResize); // Add event listener for resize

        return () => {
            window.removeEventListener('resize', handleResize); // Cleanup on component unmount
        };
    }, []);

    useEffect(() => {
        setFullPageLoading(true)
        setTimeout(() => {
            setFullPageLoading(false)
        }, 3000);
    }, [])



    const handleQuizSuccess = () => {
        setIncludeQuiz(true);
        setIsQuizPassed(true);
    };


    const isCompleted = includeTrainingVideo && includeQuiz;
    // Settings for the carousel
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: screenSize === 'mobile' ? 1 : screenSize === 'tablet' ? 3 : screenSize === 'desktop' ? 3 : 2,
        slidesToScroll: 1
    };

    const settingsSubCourse = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: screenSize === 'mobile' ? 1 : screenSize === 'tablet' ? 3 : screenSize === 'desktop' ? 4 : 2,
        slidesToScroll: 1
    };



    const convertToPreviewUrl = (url) => {
        return url ? url.replace("/view", "/preview") : "";
    };


    const downloadBadge = () => {
        const link = document.createElement('a');
        link.href = normalizeMediaUrl(completeionBadgde, 'download');
        window.open(normalizeMediaUrl(completeionBadgde, 'download'), '_blank');
    };

    const shareOnLinkedIn = () => {
        const badgeUrl = encodeURIComponent(normalizeMediaUrl(completeionBadgde, 'image'));
        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${badgeUrl}`;
        window.open(linkedInUrl, '_blank');
    };





    return (
        <>
            {isLoadingData && <LoadingScreen text="Loading.." />}
            {isLoadingDetails && <LoadingScreen text="Loading.." />}


            <BackNavbarLearning activeTabSales={"LEARNING_HUB"}/>


            <div className='background-color-course'>
                <div className='container'>
                    <h1 className='micro-certs-det-training-name'>{TrainingData?.title}</h1>
                    <p className='micro-certs-det-training-details'>{TrainingData?.fullDescription} </p>
                    <br></br>
                    <div class="row">
                        <div class="col-lg-8 col-md-12">

                            <div className="video-container">
                                {TrainingData?.video ? (
                                        <div className="video-wrapper" onContextMenu={handleContextMenu}>
                                            <div className="custom-react-player">
                                                {getMediaProvider(TrainingData?.video) === 'google-drive' ? (
                                                    <iframe
                                                        src={normalizeMediaUrl(TrainingData?.video, 'preview')}
                                                        title="Training video"
                                                        width="100%"
                                                        height="100%"
                                                        frameBorder="0"
                                                        allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                                                        allowFullScreen
                                                    />
                                                ) : (
                                                <ReactPlayer
                                                    url={TrainingData?.video}
                                                    controls
                                                    playing={playing}
                                                    width="100%"
                                                    height="100%"
                                                    light={normalizeMediaUrl(TrainingData?.thumbnail, 'thumbnail')}
                                                    playIcon={
                                                        <button className="custom-play-button" onClick={handlePlayButtonClick}>
                                                            ▶️
                                                        </button>
                                                    }
                                                />
                                                )}
                                            </div>
                                        </div>
                                ) : (
                                    <p>Video not available</p>
                                )}
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12">
                            <div className='module-details-sec'>
                                <h1 className='module-details-detail'>Details</h1>
                                <div className='cour-dist'>
                                    <p className='course-dist-det-v2'><span className='cougrse-dist-det-one'>&#8226; {TrainingData.completionTime}</span>    <span className='course-dist-det-two'>&#8226; 1 module</span></p>
                                </div>
                            </div>
                            <br></br>
                            <div className='module-details-sec'>
                                <h1 className='module-details-detail'>Progress</h1>
                                <div className="checkbox-container">
                                    <input
                                        type="checkbox"
                                        id="trainingVideoCheckbox"
                                        checked={includeTrainingVideo}
                                        onChange={handleTrainingVideoChange}
                                        disabled={includeTrainingVideo}
                                    />
                                    <label htmlFor="trainingVideoCheckbox">Training Video</label>
                                </div>


                                {includeTrainingVideo && (
                                    <div className='quize-btn-flex'>
                                        <div className="checkbox-container">
                                            <input
                                                type="checkbox"
                                                id="quizCheckbox"
                                                checked={includeQuiz || isQuizPassed} // Automatically check if quiz is passed
                                                onChange={handleQuizChange}
                                                disabled={true}
                                            />
                                            <label htmlFor="quizCheckbox">Quiz</label>
                                        </div>

                                        {/* Hide the "Start Quiz" button if the quiz is passed */}
                                        {!isQuizPassed && (
                                            <p className="start-quize-not" onClick={() => setShowQuizModal(true)}>
                                                Start Quiz
                                            </p>
                                        )}
                                    </div>
                                )}




                                <Modal
                                    {...props}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
                                    centered
                                    show={showQuizModal}
                                    backdrop="static"
                                >
                                    <Modal.Body className='quiz-background-top'>
                                        <div className='quick-assest-modal'>
                                            <h1 className='quick-assesstment'>Quick Assessment</h1>
                                            <p className='quick-assetment-p'>This questionnaire is designed to gauge your understanding and ensure you've grasped the key concepts. </p>
                                            <button className="close-button" onClick={handleCloseQuizModal} ><span aria-hidden="true">&times;</span></button>
                                        </div>
                                        <Quiz
                                            questions={question}
                                            certName={microcertTitle}
                                            id={decryptId(id)}
                                            onClose={() => setShowQuizModal(false)}
                                            onSuccess={handleQuizSuccess} />
                                    </Modal.Body>
                                </Modal>


                                {/* Conditionally render the "Mark as Completed" button */}
                                {isCompleted ? (
                                    <>
                                        <button className="mark-as-complte-green" disabled={!isCompleted}>
                                            Completed <span>&#10004;</span>
                                        </button>
                                        <br></br>
                                        <button className="download-badge" disabled={!includeQuiz || !includeTrainingVideo} onClick={() => handleShowBadgdeModel()}>
                                            <span><i class="fa-solid fa-certificate"></i></span>  View Badge
                                        </button>
                                        <br></br>
                                        <Link to='/home'>
                                            <button className="download-badge-back" disabled={!includeQuiz || !includeTrainingVideo}>
                                                <span><i class="fa-solid fa-chevron-left"></i></span> Back To Homepage
                                            </button>
                                        </Link>
                                    </>
                                ) : (
                                    <>
                                        <br></br>
                                        <div class="instructions">
                                            <h2 className='module-details-detail'>Instructions</h2>
                                            <ul>
                                                <li className='instruction-list'>After watching the video, check the "Training Video" box.</li>
                                                <li className='instruction-list'>Click "Start Quiz" to begin.</li>
                                                <li className='instruction-list'>Score at least 80% to pass.</li>
                                            </ul>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div>
                    </div>


                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>




                    <p className='available-tracks'>Available Tracks (3)</p>

                    {AllTracks?.map((track, index) => {
                        return (
                            <div class="course-card" key={track?.trackTitle}>
                                <div class="course-image">
                                    <img src={normalizeMediaUrl(track?.thumbnail, 'image')} alt="Course Showcase" />
                                </div>
                                <div class="course-details">
                                    <h1 className='training-title'>{track?.trackTitle}</h1>
                                    <div class="line-lear"></div>
                                    <div className='cour-dist'>
                                        <p className='course-dist-det'>
                                            <span className='cougrse-dist-det-one'>&#8226; {track?.totalDuration}</span>
                                            <span className='course-dist-det-two'>&#8226; {track?.microcertsList.length} Microcerts</span>
                                        </p>
                                    </div>
                                    <p className='para-lear'>{track?.trackDescription}</p>
                                    <Link to={`${PATH.LEARNING_HUB_TRACKS_PATH}${track?.trackTitle}`}><p class="launch-button">Show Courses <i class="fa-solid fa-angles-right"></i></p></Link>
                                </div>
                            </div>
                        );

                    })}

                </div>



                {/* Badgde Model */}
                <Modal
                    {...props}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    show={badgeModel}
                    onHide={() => handleCloseBadgdeModel()}
                    fullscreen={false}
                >
                    <Modal.Body className='badgde-body'>
                        <img className='badgde-cert' src={normalizeMediaUrl(completeionBadgde, 'image')} alt="Completion badge" />
                        <div className='badgde-btn'>
                            <button className='download-badgde' onClick={downloadBadge}>Download Badge</button>
                            <button className='share-linkdin' onClick={shareOnLinkedIn}>Share On LinkedIn</button>
                        </div>
                    </Modal.Body>
                </Modal>


            </div>





        </>
    )
}

export default DemoCentralTraining
